import { HANDLE_AREA_HEIGHT } from '../../bottom-sheet';

export const POPOVER_CELL_SIZE = 36;
export const BOTTOM_SHEET_CELL_SIZE = 48;
export const CELL_SIZE_MARGIN = 4;
export const BOTTOM_SHEET_CAPTION_HEIGHT = 72;
export const BOTTOM_SHEET_FOOTER_HEIGHT = 90;
export const MIN_SATE_PADDING_TOP = 40;
export const BOTTOM_SHEET_TABLE_MARGIN = BOTTOM_SHEET_CAPTION_HEIGHT - HANDLE_AREA_HEIGHT;
